export default __webpack_public_path__ + "assets/images/6ab8442b568d76ed45a802d75e121fda.jpg";